import { render, staticRenderFns } from "./Trip.vue?vue&type=template&id=4f398a83&scoped=true"
import script from "./Trip.vue?vue&type=script&lang=js"
export * from "./Trip.vue?vue&type=script&lang=js"
import style0 from "./Trip.vue?vue&type=style&index=0&id=4f398a83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f398a83",
  null
  
)

export default component.exports